const images = import.meta.glob('../../assets/guild-decorations/renown/*.webp', { eager: true, query: '?url', import: 'default' });
export const rankStageImage = stage => images['../../assets/guild-decorations/renown/level-'+stage+'.webp'];
